// extracted by mini-css-extract-plugin
export default {"root":"SectorKPIsTable_root__M+7b3","cell":"SectorKPIsTable_cell__1wAPv"};